import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { db } from '../utils/firebase';
import { collection, query, where, getDocs, updateDoc, serverTimestamp } from 'firebase/firestore';

const UnsubscribePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error' | 'already' | 'not-found'>('loading');
  const email = searchParams.get('email');

  useEffect(() => {
    const processUnsubscribe = async () => {
      if (!email) {
        setStatus('error');
        return;
      }

      try {
        // Find subscriber by email
        const q = query(collection(db, 'subscribers'), where('email', '==', email.toLowerCase()));
        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          setStatus('not-found');
          return;
        }

        const subscriberDoc = snapshot.docs[0];
        const data = subscriberDoc.data();

        // Check if already unsubscribed
        if (data.unsubscribedAt) {
          setStatus('already');
          return;
        }

        // Update subscriber
        await updateDoc(subscriberDoc.ref, {
          unsubscribedAt: serverTimestamp()
        });

        setStatus('success');
      } catch (error) {
        console.error('Unsubscribe error:', error);
        setStatus('error');
      }
    };

    processUnsubscribe();
  }, [email]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <img
          src="/assets/logo/4HVNSK8-logo-black.svg"
          alt="4HVNSK8"
          className="h-12 mx-auto mb-8"
        />
        {status === 'loading' && (
          <p className="text-gray-600">Processing your request...</p>
        )}
        {status === 'success' && (
          <>
            <h1 className="text-2xl font-bold mb-4">You've Been Unsubscribed</h1>
            <p className="text-gray-600">You will no longer receive marketing emails from us.</p>
          </>
        )}
        {status === 'already' && (
          <>
            <h1 className="text-2xl font-bold mb-4">Already Unsubscribed</h1>
            <p className="text-gray-600">This email address is already unsubscribed.</p>
          </>
        )}
        {status === 'not-found' && (
          <>
            <h1 className="text-2xl font-bold mb-4">Email Not Found</h1>
            <p className="text-gray-600">We couldn't find this email in our subscriber list.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="text-2xl font-bold mb-4">Something Went Wrong</h1>
            <p className="text-gray-600">Please try again or contact support.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
